(ns frontend.ui.component.lp-portal.country-multiselect.view
  (:require
   [frontend.ui.component.lp-portal.multiselect.view :as multiselect]
   [common.country :as country]))

(defn country-multiselect
  [props]
  (fn [{:keys [selected-countries on-countries z-index] :as props}]
    [multiselect/multiselect
     {:placeholder  "Select countries..."
      :selected-ids selected-countries
      :on-select    (fn [id]
                      (-> selected-countries
                          (conj id)
                          (set)
                          (on-countries)))
      :on-deselect  (fn [id]
                      (-> selected-countries
                          (disj id)
                          (set)
                          (on-countries)))
      :options      (concat
                     (->> [{:id :FI :label "Finland"} {:id :SE :label "Sweden"}]
                          (map
                           (fn [partial-option]
                             (assoc partial-option :category "Suggestions"))))
                     (->> (country/localized-options :en)
                          (map
                           (fn [country]
                             {:id       (:keyword country)
                              :label    (:label country)
                              :category "All countries"}))))
      :z-index      z-index}]))
